function init_dobblegame(from_php){
    if(typeof from_php.girl_id=="undefined" || from_php.girl_id==0){
        return false;
    }
    if(_ON_DEV){
        console.log(from_php);
    }
    var main=$(".place.dobblegame");


    var semaphoreSuit= new mySemaphore();

    var girl_id=intval(from_php.girl_id);

    var timeIndexArr={
        "ajax":_moduleTimeHandler.getNewIndex(),
        "wrong":_moduleTimeHandler.getNewIndex(),
        "timeout":_moduleTimeHandler.getNewIndex(),
        "timeout_error":_moduleTimeHandler.getNewIndex(),
        "loader":_moduleTimeHandler.getNewIndex()
    };

    var girl_name=$.takeGirlImage(girl_id);

    var gameCover=main.find("#gameCover");
    var gameCoverState=main.find(".stateJS"),gameCoverWin;
    var state_cur="";
    var game_state="";
    var game_start=0;
    var secureStr=from_php.secure;

    var game;


    $.handleBottomMenu();

    main.find(".bookGame").one("open",function(){
        var radius=0,dir_rot=2,dir=1,step=0,obj=main.find(".formSubmit.butLoader.soccer"),
        circleObj=obj.find(".img"),textObj=obj.find(".in"),step_mig=20;
        _moduleTimeHandler.set(timeIndexArr.loader,function(){
            radius=(radius+dir_rot)%360;
            step+=dir;
            circleObj.cssrotate(radius);
            if(step%step_mig<step_mig/2){
                textObj.addClass("hide");
            }
            else{
                textObj.removeClass("hide");
            }
        },50);
    });
    main.find(".bookGameIns").on("close",function(){
        main.find(".bookGame").bookUse("show");
        return false;
    });

    function postAjax(to_send,refuse_response,on_end){
        if(semaphoreSuit.use()){
            var data_send={girl_id:girl_id,page:"dobblegame"};
            data_send=$.extend(data_send,to_send);

            function onError(data_send){
                if(typeof data_send.game_conf=="undefined"){
                    return false;
                }
                _eventLogout.add(data_send);
            }

            $.mypost('/ajax',data_send, function(res) {
                var data=handleAjaxRes(res),was_clear=0;
                if(typeof data!="undefined" && data){
                    if(intval(data.level)>intval(from_php.level)){
                        _mySound.playSound("girl_smile");
                    }
                    if(intval(data.was_ended)>intval(from_php.was_ended)){
                        _mySound.playSound("dobble_win");
                        //{$qconf.action_anim}/{$qevent_id}/{$g_id}/

                        $.goToLocation("dobbleanim/"+from_php.event_id+"/"+girl_id+"/",{arrow:1});
                        return false;
                    }
                    if(typeof data.bought_live!="undefined"){
                        game.buyLife();
                    }
                    from_php=$.extend(from_php,data);
                    function isEnd(){
                        if(!refuse_response){
                            updateState();
                        }
                        if(typeof on_end=="function"){
                            on_end();
                        }
                    }
                    if(data_send.wait){
                        _moduleTimeHandler.setOne(timeIndexArr.ajax,function(){
                            isEnd();
                        },1500);
                    }
                    else{
                        isEnd();
                    }

                }
                else{
                    onError(data_send);
                }
                semaphoreSuit.clear();
            },"json");
        }
    }




    function updateState(){
//        showState("game_init");
//        return false;





        if(from_php.was_error){
            showState("wrong");
        }
        else if(from_php.time_game){
            showState("game");
        }
        else{
            if(from_php.was_paid==0){
                if(from_php.try_count>0){
                    showState("init");
                }
                else{
                    showState("need_try");
                }
            }
            else if(from_php.was_shown==0){
                showState("next");
            }
            else{
                showState("game_init");
            }
        }
        main.attr("data-level",(intval(from_php.level_show)+1))
    }


    function init(){
        main.find(".butNextLevelStartJS").click(function(){
            _mySound.playSound("button_click");
            postAjax({prepare_init:1});


        });
        main.find(".buyGirlDateJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_date:1});
            });
        });
        main.find(".repeatMoveTriggerJS").click(function(){
            _mySound.playSound("button_click");
           var th=$(this),premium_count=intval(th.attr("data-need"));
           $.payByPremium(premium_count,function(){
                postAjax({buy_repeat:1});
            });
        });
        main.find(".repeatMoveFirstTriggerJS").click(function(){
            _mySound.playSound("button_click");
            var th=$(this),premium_count=intval(th.attr("data-need"));
            $.payByPremium(premium_count,function(){
                postAjax({buy_repeat:1,buy_first:1});
            });
        });

        updateState();
    }


    var stateFun={
        "wrong":function(win){
            var book=main.find(".popup.wrong");
            var size="big";
            var win_obj={"repeat":1,"continue":1};
            if(from_php.level_show<2){
                win_obj.repeat=0;
            }
            book.find("#failReasonJS").html(from_php.langs["fail"+from_php.was_error]);


            if(from_php.cards_err==0 || from_php.cards_err==from_php.conf.card_max){
                win_obj.continue=0;
            }

//            win_obj={"repeat":0,"continue":0};

            if(win_obj.repeat==0){
                main.find(".repeatMoveJS").addClass('hide');
            }
            else{
                main.find(".repeatMoveJS").removeClass('hide');
            }
            if(win_obj.continue==0){
                main.find(".nextMoveContJS").addClass('hide');
            }
            else{
                main.find(".nextMoveContJS").removeClass('hide');
                book.find("#countCardJS").html(from_php.cards_err);
            }


            if(win_obj.repeat==0 && win_obj.continue==0){
                size="mini";
            }
            book.attr("data-size",size);

        },
        "init":function(){

        },
        "need_try":function(){

        },
        "next":function(win){
            main.find(".putGameJs[data-type='level']").html(intval(from_php.level_show)+1);


        },
        "game_init":function(){
            var book=main.find(".popup.game_init");
            var size="big";

            var start_type=0;

            if(intval(from_php.level)<2){
            }
            else{
                start_type=1;
                size="mini";
            }

            book.attr("data-size",size);
            main.find(".gameContentJS[data-type]").addClass("hide").
            filter("[data-type='"+start_type+"']").removeClass("hide");



            if(intval(from_php.level)<2){
                game.initHowto();
            }
            else{
                main.find("#startGameNowJS").off("click").on("click",function(){
                    game.startGame();
                    _mySound.playSound("button_click");
                });

            }










            _moduleEvents.on("dobblesound",function(val){
                if(val=="hit"){
                    _mySound.playSound("dobble_punch");
                    if(mt_rand(1,100)>50){
                        _mySound.playSound("dobble_ouch");
                    }
                    else{
                        _mySound.playSound('dobble_yeah');
                    }

                }
            });



        },
        "game":function(){
             main.find(".hideOnGameJS").addClass("hide");
             main.find(".showOnGameJS").removeClass("hide");
        }
    };
    function showState(state){

        main.find(".putGameJs[data-type='try']").html(from_php.try_count);
        main.find(".arrSetCountJS").attr("data-count",from_php.try_count);
        _timerManager.addTimer(".place.dobblegame .timerKeyWaitJS",from_php.try_time,1);
        _moduleTimeHandler.clear(timeIndexArr.timeout);

        if(state!="game"){
            main.find(".hideOnGameJS").removeClass("hide");
            main.find(".showOnGameJS").addClass("hide");
            gameCover.removeClass("hide");
        }


        state_cur=state;

        gameCoverWin=gameCoverState.addClass("hide").filter("[data-state='"+state+"']").removeClass("hide");
        gameCoverWin.find(".textfill").textfill();
        if(typeof stateFun[state]=="undefined"){
            alert(state+"!");
        }
        stateFun[state](gameCoverWin);
    }








    function gameAll(){
        var walkObj;


        var thc=this;
        this.afterInit=new afterInit();

        function startDev(){
            main.find(".bookGameIns.book").off("close").bookUse("hide");

            main.find(".hideOnGameJS").addClass("hide");
            game_start=getCurrentTime();
            game_state="game";


            walkObj.initGame();

            var count_down=4,qindex=_moduleTimeHandler.getNewIndex();
            var countObj=main.find("#readyJS #countDown");
            _moduleTimeHandler.set(qindex,function(){
                count_down--;
                if(count_down>0){
                    countObj.html(count_down);
                    _mySound.playSound("pvpgo_end");
                }
                else{
                    _mySound.playSound("pvpgo_start");
                    countObj.remove();
                    _moduleTimeHandler.clear(qindex);
                    walkObj.start();
                }

            },1000);

        }
        function wasLoaded(){
            main.find(".gameIsLoadingJS").addClass("hide");
            main.find(".gameIsLoadedJS").removeClass("hide");


            main.find(".gameIsLoadedJS").find(".textfill").textfill();

            walkObj.initBackground(main.find("#gameWrapJS"));
            _moduleTimeHandler.clear(timeIndexArr.loader);
            thc.afterInit.load();
        }

        function fadeOutText(obj,onEnd){
            obj.show();
            var opacity=200,qindex=_moduleTimeHandler.getNewIndex();
            _moduleTimeHandler.set(qindex,function(){
                opacity-=5;

                if(opacity<=0){
                    _moduleTimeHandler.clear(qindex);
                    obj.remove();
                    onEnd();
                }
                else{
                    obj.css("opacity",Math.min(100,opacity)/100);
                }
            },50);
        }
        var lastState={win_id:0,cards:{own:20,enemy:20}};
        var card_max=from_php.conf.card_max;
        if(from_php.cards_err!=0){
            card_max=from_php.cards_err;
        }
        walkObj=new dobbleGame({
            girl_id:from_php.girl_id,
            game:{
                set_id:from_php.conf.set_id,
                card_max:card_max,
                card_max_real:from_php.conf.card_max,
                own_howlong:from_php.conf.own_howlong,
                enemy_howlong:from_php.conf.enemy_howlong,
                random_own:from_php.conf.random_own,
                bonus1:from_php.bonus1,
                bonus2:from_php.bonus2
            },
            langs:{
                "card_own":from_php.langs.card_own,
                "card_cur":from_php.langs.card_cur
            },
            onLoad:function(){
                wasLoaded();
            },
            onUpdateState:function(res){
                var type;
                for(type in res.cards){
                    main.find("#readyJS .cardsWrap[data-type='"+type+"'] .cardNum").html("x"+res.cards[type]);
                }
                lastState=res;

            },
            onMoveEnd:function(){
                if(lastState.win_id==1){
                    this.cardsAll.cur.fadeOut(25);
                    //win
                    fadeOutText(main.find("#winText"),function(){
                        postAjax({
                            game_conf:Base64.encode(secureStr),
                        });
                    });

                }
                if(lastState.win_id==2){
                    //lose
                    this.cardsAll.cur.fadeOut(25);
                    this.cardsAll.own.fadeOut(25);
                    fadeOutText(main.find("#failText"),function(){

                        postAjax({
                            was_error:2,
                            own_cards:lastState.cards.own,
                            sec:Base64.encode(secureStr)
                        });
                    });

                }

            }
        });
        walkObj.startLoader();
        this.walkObj=walkObj;

        this.tryStart=0;
    }
    gameAll.prototype={
        init:function(){
        },
        initHowto:function(){
            var thc=this;
            this.afterInit.addFun(function(){
                thc.walkObj.initHowto(main.find("#wrapCanvasInit"),function(){
                    thc.privateStartGame();
                });
            });
        },
        startGame:function(){
            if(this.tryStart){
                return false;
            }
            this.tryStart=1;
            var thc=this;
            this.afterInit.addFun(function(){
                thc.privateStartGame();
            });
            return true;
        },
        privateStartGame:function(){
            gameCover.addClass("hide");
            var thc=this;
            postAjax({start_game:1},0,function(){
                thc.walkObj.initGame(main.find("#gameWrapJS"));

                var count_down=4,qindex=_moduleTimeHandler.getNewIndex();
                var countObj=main.find("#readyJS #countDown");
                _moduleTimeHandler.set(qindex,function(){
                    count_down--;
                    if(count_down>0){
                        _mySound.playSound("pvpgo_end");
                        countObj.html(count_down);
                    }
                    else{
                        _mySound.playSound("pvpgo_start");
                        countObj.remove();
                        _moduleTimeHandler.clear(qindex);
                        thc.walkObj.start();
                    }

                },500);
            });

        }
    };

    game=new gameAll();

    init();


//    main.find(".bookGame").css("background-image","none").
//    find(".up,.down").css("background-image","none").end().
//    find(".ball_down").addClass("hide").end().
//    find(".bottom_row").addClass("hide");

}
